
// 2020-11-13 - HTML input date format
export const parseDate = (date) => {
    let newDate
    if(date) {
        const splitDate = date.split('/')
        let day = parseInt(splitDate[1])
        if(day < 10){
            day = '0' + day
        }
        let month = parseInt(splitDate[0])
        if(month < 10){
            month = '0' + month
        }
        newDate = splitDate[2] + '-' + month + '-' + day
        return newDate
    } else {
        const d = new Date()
        let day = d.getDate()
        if(day < 10){
            day = '0' + day
        }
        let month = (d.getMonth() + 1)
        if(month < 10){
            month = '0' + month
        }
        newDate = d.getFullYear() + '-' + month + '-' + day
    }
    return newDate
}

// out = app format (7/24/2020)
// in = 2020-11-13 
export const localParse = (inDate) => {
    let d
    if(inDate) {
        const spl = inDate.split('-')
        d = new Date(parseInt(spl[0]), parseInt(spl[1]) - 1, parseInt(spl[2]))
    } else {
        d = new Date()
    }
    const finalDate = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
    return finalDate
}

export const dateGreaterThan = (dateOne, dateTwo) => {
    if(dateOne === dateTwo) return false
    const dateOneSplit = dateOne.split('/').map(d => parseInt(d))
    const dateTwoSplit = dateTwo.split('/').map(d => parseInt(d))
    if(dateOneSplit[2] > dateTwoSplit[2]) return true
    if(dateOneSplit[0] > dateTwoSplit[0]) return true
    if(dateOneSplit[1] > dateTwoSplit[1]) return true
    return false
}